<template>
  <div class="row">
    <div v-for="field in fields" :key="field.attribute" class="col-sm-5">
      <field :field="field" :model="model" layout="vertical" />
    </div>
    <div class="col-sm align-self-center">
      <b-button variant="primary" block @click="submit">
        {{ $t('general.add') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { FormRelationField } from 'stylemix-base'

export default {
  components: {
    FormRelationField,
  },

  data() {
    return {
      model: {
        airport_id: null,
        direction: null,
      },

      fields: [
        {
          label: 'Airport',
          component: 'relation-field',
          attribute: 'airport_id',
          ajax: true,
          source: {
            url: '/airports',
            params: {
              context: 'options',
              primary_key: 'id',
            },
          },
        },
        {
          label: this.$t('general.direction'),
          component: 'select-field',
          attribute: 'direction',
          options: [
            {
              label: this.$t('general.both'),
              value: 'both',
            },
            {
              label: this.$t('general.to'),
              value: 'to',
            },
            {
              label: this.$t('general.from'),
              value: 'from',
            },
          ],
        },
      ],
    }
  },

  methods: {
    submit() {
      if (!this.model.airport_id || !this.model.direction) {
        return
      }
      this.$emit('submit', this.model)
    },
  },
}
</script>
